module.exports = __webpack_public_path__ + "static/media/Startbild_ohne_Chart.4526dbcf.png";